import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function OutsourcingCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contractor.create(0, "outsourcing"));
  };

  return (
    <MainMenuItem
      itemTitleString="委託先を登録する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default OutsourcingCreateMenuItem;
